export function formatString(input: string | undefined) {
  if (!input) {
    return ''
  }
  const words = input
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .split(/[\s_-]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))

  return words.join(' ')
}
